import { memo } from 'react';

import styles from './AmbientBackground.module.scss';

/**
 * The light behind the glass.
 *
 * Glass over a flat colour reads as a grey box; it needs colour and
 * structure behind it to have anything to tint and bend. This layer
 * supplies both: soft fields of colour, a faint grid whose straight lines
 * make refraction visible at a glance, and film grain so large gradients
 * never band.
 *
 * Purely decorative and fixed behind everything. It never re-renders.
 */
export const AmbientBackground = memo(() => (
  <div className={styles.ambient} aria-hidden="true">
    <div className={styles.field} data-field="1" />
    <div className={styles.field} data-field="2" />
    <div className={styles.field} data-field="3" />
    <div className={styles.field} data-field="4" />
    <div className={styles.grid} />
    <div className={styles.grain} />
  </div>
));

AmbientBackground.displayName = 'AmbientBackground';
